import { useSelector } from 'react-redux';
import Location from '@solvhealth/types/interfaces/Location';
import { useMemo } from 'react';
import { getCurrentlySelectedLocationFromState } from '../../core/util/location';
import { getServicePrices } from '~/components/ClinicDetailPageFlexible/components/SelfPay';
import { getAllV1ServicePrices } from '~/components/ClinicDetailPageFlexible/components/SelfPay/util/getServicePrices';

export const useSelectActiveLocation = () => {
  return useSelector<any, ReturnType<typeof getCurrentlySelectedLocationFromState>>(
    getCurrentlySelectedLocationFromState
  );
};

/** Retrieves a memoized mapping of clinic service names -> prices from a location's 'serviceObjs' data
 *
 * @returns The service prices */
export const useServicePrices = (location: Location, allV1Services = false) => {
  const servicesObj = useMemo(() => location?.servicesObj ?? {}, [location]);
  // TODO: Fix this as any; getServicePrices needs to use ServicesObj
  // The only reason it doesn't is b/c ServicesObj is the wrong type, see comment in
  // getServicesPrices

  return useMemo(() => {
    if (allV1Services) {
      return getAllV1ServicePrices(servicesObj as any);
    }
    return getServicePrices(servicesObj as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [servicesObj]);
};
